import * as React from "react";
import { cn } from "../../lib/utils";

type Tone = "default" | "gold" | "muted" | "teal" | "protein";

export interface IconProps extends React.HTMLAttributes<HTMLSpanElement> {
  size?: number;
  tone?: Tone;
  children: React.ReactNode;
}

export const Icon = ({
  size = 24,
  tone = "default",
  className,
  children,
  ...rest
}: IconProps) => (
  <span
    aria-hidden
    data-tone={tone === "default" ? undefined : tone}
    className={cn(
      "p2p-svg inline-flex shrink-0 items-center justify-center",
      className,
    )}
    style={{ width: size, height: size }}
    {...rest}
  >
    {children}
  </span>
);
